// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-header {
    text-align: center;
    position: relative;
    height: 58px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    top: env(safe-area-inset-top, 0);
    background-color: #fff;
    z-index: 2;
    border-radius: 5px 5px 0px 0px;
}

.survey-header .back-button {
    position: absolute;
    left: 20px;
    top: 20px;
    color: #0067B1;
    cursor: pointer;
}

.survey-header .save-exit-button {
    position: absolute;
    right: 85px;
    top: 20px;
    color: #0067B1;
    cursor: pointer;
}

.survey-header .cancel-button {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #0067B1;
    cursor: pointer;
}

.survey-header .done-button {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #0067B1;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyHeader/SurveyHeader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,MAAM;IACN,gCAAgC;IAChC,sBAAsB;IACtB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,eAAe;AACnB","sourcesContent":[".survey-header {\n    text-align: center;\n    position: relative;\n    height: 58px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    top: env(safe-area-inset-top, 0);\n    background-color: #fff;\n    z-index: 2;\n    border-radius: 5px 5px 0px 0px;\n}\n\n.survey-header .back-button {\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    color: #0067B1;\n    cursor: pointer;\n}\n\n.survey-header .save-exit-button {\n    position: absolute;\n    right: 85px;\n    top: 20px;\n    color: #0067B1;\n    cursor: pointer;\n}\n\n.survey-header .cancel-button {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    color: #0067B1;\n    cursor: pointer;\n}\n\n.survey-header .done-button {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    color: #0067B1;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
